import config from 'config';

import { ProductType } from '~/techstyle-shared/react-products';

import { getAvailableProductQuantity } from './getAvailableProductQuantity';
import { isForcedSoldOut as getIsForcedSoldOut } from './isForcedSoldOut';

export const isSoldOut = (options) => {
  const { product, isVip = false, isGridCallout = false } = options;

  if (!product) {
    return false;
  }

  const soldOutForcedCheck = config.get(
    'public.brand.features.soldOutForcedCheck'
  );
  if (soldOutForcedCheck) {
    const isForcedSoldOut = getIsForcedSoldOut(product, isVip);

    if (isForcedSoldOut) {
      return true;
    }

    // FIXME: This can be removed once a fix is added for returning a more accurate
    // available quantity for SXF Sets products through Constructor
    // The Tag ID Behavior will be handled above, so we are skipping the quantity check
    if (isGridCallout && product.productTypeId === ProductType.BUNDLE) {
      return false;
    }
  }

  const availableProductQuantity = getAvailableProductQuantity(product);
  return availableProductQuantity === 0;
};
